import { apiJson, type ApiFetchInit } from "../../api/client";
import type { Account } from "../types";

export function getAccount(accountId: string, init: ApiFetchInit = {}): Promise<Account> {
  return apiJson<Account>(`/team/account/${encodeURIComponent(accountId)}`, init);
}

export function updateMemberRole(
  accountId: string,
  userId: string,
  role: string,
  init: ApiFetchInit = {},
): Promise<{ ok: true }> {
  return apiJson<{ ok: true }>(
    `/team/account/${encodeURIComponent(accountId)}/user/${encodeURIComponent(userId)}`,
    {
      ...init,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...init.headers },
      body: JSON.stringify({ accountRole: role }),
    },
  );
}
